/**
 * Deploy-time paths (baked in by Vite at build).
 *
 * Portable Plesk package (default):
 *   VITE_BASE=/next/  VITE_API_BASE=/api/index.php
 *   (PATH_INFO style — works on nginx without extra rewrite rules)
 *
 * With pretty /api/* rewrite configured:
 *   VITE_API_BASE=/api
 *
 * Beside classic Ext monorepo:
 *   VITE_BASE=/na/next/  VITE_API_BASE=/na/api/v1
 */
export const API_BASE = import.meta.env.VITE_API_BASE || '/api/index.php'
export const APP_BASE = import.meta.env.BASE_URL || '/next/'
/** Empty = classic Ext UI not used (portable package). */
export const CLASSIC_BASE = (import.meta.env.VITE_CLASSIC_BASE as string) || ''
